import { render, staticRenderFns } from "./ym.vue?vue&type=template&id=1914081a&scoped=true&"
import script from "./ym.vue?vue&type=script&lang=js&"
export * from "./ym.vue?vue&type=script&lang=js&"
import style0 from "./ym.vue?vue&type=style&index=0&id=1914081a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914081a",
  null
  
)

export default component.exports